import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'shared/components/alerts';

export const useLimitedCompanyRouteNotAvailableAlert = (isLimited: boolean, isAllowed: boolean) => {
  const { alertError } = useAlert();
  const { t } = useTranslation('web-common');
  const hasShownToastRef = useRef(false);

  useEffect(() => {
    if (!isLimited || isAllowed || hasShownToastRef.current) {
      return;
    }
    hasShownToastRef.current = true;
    alertError(
      new Error(
        t('company.limited.route-not-available', {
          defaultValue: 'Not available for your company',
        })
      )
    );
  }, [alertError, isAllowed, isLimited, t]);
};
